module.exports = __webpack_public_path__ + "image/wb-icon.png";